import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

import {
  ApplePaymentToken,
  AppleTokenPaymentMethod,
  CreditCardModel,
} from '@/logic/services';
import { TopUpModel } from '../services/types';
import { CreditCardCvvModel } from '@/components/checkout/payment-methods';

interface TopUpDetailedModel extends TopUpModel {
  amount: number;
}

interface WalletModel {
  topUp?: Partial<TopUpDetailedModel>;
  minAmountTopUp?: number;
  maxAmountTopUp?: number;
  temporaryAddedCreditCards?: CreditCardModel[];
  selectedCard?: number;
  isApplePaymentSelected?: boolean;
  selectedCreditCardValidCvv?: string;
  creditCardsCvvList?: CreditCardCvvModel[];
  handleCreditCardsCvvListChange?: (creditCardCvvNewValue: CreditCardCvvModel) => void;
  handlePayOrder?: (
    cardId: number,
    cardCvv: string,
    isApplePay?: boolean,
    applePayPaymentData?: ApplePaymentToken | string,
    applePaymentMethod?: AppleTokenPaymentMethod
  ) => void;
}

export type WalletState = {
  wallet: WalletModel;
};

const initState: WalletState = {
  wallet: null,
};

export const useWalletStore = createStore({
  name: 'wallet',
  devtools: isDevtoolsEnabled,
  persist: true,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setWallet: handler('wallet'),
  };
});
